import { render, staticRenderFns } from "./Yield.vue?vue&type=template&id=fa70d136&scoped=true&"
import script from "./Yield.vue?vue&type=script&lang=js&"
export * from "./Yield.vue?vue&type=script&lang=js&"
import style0 from "./Yield.vue?vue&type=style&index=0&id=fa70d136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa70d136",
  null
  
)

export default component.exports